import type { RouteArgs } from '@ember/routing/lib/utils';
import type RouterService from '@ember/routing/router-service';
import type { RouteInfo } from '@ember/routing/router-service';
import type Model from 'ember-data/model';
import type { QueryParams } from 'global';

export type LinkInfo = {
  route: string | undefined;
  routeModels: (string | Model)[];
  routeQuery: Record<string, unknown>;
};

export function getLinkInfo(
  recognizeRoute: (href: string) => RouteInfo | null,
  href: string
): LinkInfo | undefined {
  let routeInfo = recognizeRoute(href);

  if (routeInfo && routeInfo.localName !== 'not-found') {
    if (routeInfo.localName === 'index' && routeInfo.parent) {
      routeInfo = routeInfo.parent;
    }

    let paramRows: any[] = [];
    let routeName = routeInfo.name;
    let queryParams = routeInfo.queryParams;

    while (routeInfo) {
      const currentParams = routeInfo.paramNames
        .map((paramName) => routeInfo?.params?.[paramName])
        .filter(Boolean);

      paramRows = [...currentParams, ...paramRows];
      routeInfo = routeInfo.parent;
    }

    return {
      route: routeName,
      routeModels: paramRows,
      routeQuery: queryParams
    };
  }
  return undefined;
}

export const handleQueryParams = (params: RouteArgs) => {
  const possibleQueryParams = params[params.length - 1];

  if (possibleQueryParams && (possibleQueryParams as QueryParams).isQueryParams) {
    // ensure to handle potentially frozen arrays
    params = params.slice() as RouteArgs;

    params[params.length - 1] = {
      queryParams: (possibleQueryParams as QueryParams).values
    };
  }

  return params;
};

export const trackActiveRoute = (router: RouterService) => {
  // ensure we recompute anytime `router.currentURL` changes
  router.currentURL;

  // ensure we recompute whenever the `router.currentRouteName` changes
  // this is slightly overlapping with router.currentURL but there are
  // cases where route.currentURL doesn't change but the
  // router.currentRouteName has (e.g. loading and error states)
  router.currentRouteName;
};
